'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var Menu = require('../../../node_modules/@material-ui/core/esm/Menu/Menu.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    shapeMenuStyleV2: {
      borderRadius: 8,
      margin: '4px 0px',
      minWidth: 152
    }
  };
});

var MenuBase = function MenuBase(_ref) {
  var classes = _ref.classes,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? '' : _ref$version,
      children = _ref.children,
      restProps = objectWithoutProperties(_ref, ["classes", "version", "children"]);

  var _useStyles = useStyles(),
      shapeMenuStyleV2 = _useStyles.shapeMenuStyleV2;

  return React__default["default"].createElement(Menu["default"], _objectSpread({
    classes: version === 'v2' ? _objectSpread({
      paper: shapeMenuStyleV2
    }, classes) : classes
  }, restProps), children);
};

module.exports = MenuBase;
